"use client"

import { useEffect, useMemo, useState } from "react"
import { useIsServer } from "./useIsServer"

// This function maybe causes "Hydration failed"
// this will happen when the user has tried to access mobile mode on a desktop device
// or vice versa

export const useDevicePassedWidth = (checker: (width: number) => any, deps?: any[]) => {
  const isServer = useIsServer()
  const [width, setWidth] = useState(isServer ? 0 : window.document.body.clientWidth)

  const windowResize = () => {
    setWidth(window.document.body.clientWidth)
  }

  useEffect(() => {
    windowResize()
    window.addEventListener('resize', windowResize)
    return () => {
      window.removeEventListener('resize', windowResize)
    }
  }, [])

  return useMemo(() => {
    return isServer || !isServer && checker(width)
  }, [width, isServer])
}